import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { AppComponent } from './app.component';
import { HttpClientModule, provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { ViewComponent } from "./view/view.component";
import { CompareComponent } from "./compare/compare.component";
import { CompareViewComponent } from './compare/compare-view/compare-view.component';
import { AppRoutingModule } from './app-routing.module';

import { HashLocationStrategy } from '@angular/common';
import { MsalModule, MsalRedirectComponent, MsalGuard, MsalInterceptor } from '@azure/msal-angular';
import { PublicClientApplication, BrowserCacheLocation, InteractionType } from '@azure/msal-browser';
import { DownloadReportComponent } from './shared/download-report/download-report.component';
import { ForcePanelDownDirective } from './shared/directives/force-panel-down.directive';
import { environment } from '../environments/environment';
import { BackendAuthInterceptor } from './services/backend-auth.interceptor';
import { LoadingInterceptor } from './services/loading.interceptor';
// import { CartComponent } from './cart/cart.component';
import { AsaFormComponent } from './asa-form/asa-form.component';
import { ChangeControlComponent } from './change-control/change-control.component';
import { CartItemComponent } from './cart/cart-item/cart-item.component';
import { DuplicateDialogComponent } from './change-control/duplicate-dialog/duplicate-dialog.component';
import { AccessControlComponent } from './access-control/access-control.component';

const isIE =
  window.navigator.userAgent.indexOf("MSIE ") > -1 ||
  window.navigator.userAgent.indexOf("Trident/") > -1;

@NgModule({
  declarations: [
    AppComponent,
    ViewComponent,
    CompareComponent,
    CompareViewComponent,
    DownloadReportComponent,
    // CartComponent
    AsaFormComponent,
    ChangeControlComponent,
    DuplicateDialogComponent,
    AccessControlComponent,
  ],
  imports: [
  BrowserModule,
  BrowserAnimationsModule,
    FormsModule,
  AppRoutingModule,
  MatIconModule,
  MatButtonModule,
  MatTooltipModule,
  MatProgressSpinnerModule,
  MatFormFieldModule,
  MatInputModule,
  MatSelectModule,
  MatDialogModule,
  ForcePanelDownDirective,
    AppRoutingModule,
    CartItemComponent,
    HttpClientModule,
    // CartComponent,
    MsalModule.forRoot(
      new PublicClientApplication({
        auth: {
          clientId: environment.msalConfig.auth.clientId,
          redirectUri: environment.msalConfig.auth.redirectUri,
          authority: environment.msalConfig.auth.authority,
          navigateToLoginRequestUrl: false
        },
        cache: {
          cacheLocation: BrowserCacheLocation.LocalStorage,
          storeAuthStateInCookie: isIE,
        },
        // Slightly higher timeouts reduce false monitor_window_timeout failures on slow networks.
        system: {
          loadFrameTimeout: 15000,
          iframeHashTimeout: 15000,
        },
      }),
      {
        interactionType: InteractionType.Redirect,
        authRequest: {
          scopes: ["User.Read", "User.Read.All", environment.msalConfig.backendApiScope]
        }
      },
      {
        interactionType: InteractionType.Redirect,
        protectedResourceMap: new Map([
          ['https://graph.microsoft.com/v1.0/me', ['User.Read']],
          ['https://graph.microsoft.com/v1.0/users', ['User.Read.All']]
        ])
      }
    )
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    {provide: HashLocationStrategy, useClass: HashLocationStrategy},
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BackendAuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    MsalGuard,
  ],
  bootstrap: [AppComponent, MsalRedirectComponent] 
})
export class AppModule { }